// extracted by mini-css-extract-plugin
export default {"products":"Tv-z","card":"Uv-z","oosMessaging":"Vv-z"};